import React from 'react'
import { IconDownload, IconMyDelete } from '../../Assets/MyIcons'
import { Link } from 'react-router-dom'
import MessageLabel from './MessageLabel'

const AdminDownloadFile = ({ className, name, value, link, icon, id, paddingClass = "px-3 py-2", gapClass = "gap-3" }) => {
    const handleDownload = async () => {
        const response = await fetch(link);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name || 'download';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>{value &&
            <a id={id || 'downloadLink'} onClick={handleDownload} className={`theme-text-color opacity-75 shadow rounded-5 cursor-pointer d-inline-block ${className}`} target='_blank' download>
                <div className={`d-flex align-items-center ${gapClass} ${paddingClass}`}>
                    {!icon ? <IconDownload styled={{ className: "download-icon", width: "20px", height: "18px" }} /> : icon}
                    <MessageLabel text={name} className='mb-sm-0' />
                </div>
            </a>
        }
        </>
    )
}

export default AdminDownloadFile
